export default __webpack_public_path__ + "static/media/nhl-player-mobile-left.bc9d07f5.png";